/* 🤖 this file was generated by svg-to-ts */
export const iconArrowDown16: {
  name: 'arrow-down-16';
  data: string;
} = {
  name: 'arrow-down-16',
  data: `<svg width="16" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M2.97 5.22a.75.75 0 0 1 1.06 0L8 9.19l3.97-3.97a.75.75 0 1 1 1.06 1.06l-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 0 1 0-1.06"/></svg>`,
};
export const iconArrowDown24: {
  name: 'arrow-down-24';
  data: string;
} = {
  name: 'arrow-down-24',
  data: `<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path d="m11.47 16.281-7.5-7.5A.75.75 0 0 1 5.03 7.72L12 14.69l6.969-6.97a.75.75 0 1 1 1.061 1.06l-7.5 7.5a.747.747 0 0 1-1.061 0Z"/></svg>`,
};
export const iconCheck16: {
  name: 'check-16';
  data: string;
} = {
  name: 'check-16',
  data: `<svg width="16" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M5.631 11.39 2.55 8.28 1.5 9.331 5.631 13.5 14.5 4.551 13.458 3.5 5.63 11.39Z"/></svg>`,
};
export const iconCheck24: {
  name: 'check-24';
  data: string;
} = {
  name: 'check-24',
  data: `<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path d="m21.53 7.28-12 12a.75.75 0 0 1-1.06 0l-5.25-5.25a.75.75 0 1 1 1.06-1.06L9 17.69 20.47 6.22a.75.75 0 1 1 1.06 1.06"/></svg>`,
};
export const iconClose16: {
  name: 'close-16';
  data: string;
} = {
  name: 'close-16',
  data: `<svg width="16" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M13.03 11.97a.751.751 0 1 1-1.062 1.062L8 9.062l-3.97 3.969a.751.751 0 1 1-1.062-1.063L6.938 8 2.969 4.03a.751.751 0 1 1 1.063-1.062L8 6.938l3.97-3.97a.751.751 0 1 1 1.062 1.062L9.062 8z"/></svg>`,
};
export const iconClose24: {
  name: 'close-24';
  data: string;
} = {
  name: 'close-24',
  data: `<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path d="M19.28 18.22a.75.75 0 1 1-1.06 1.06L12 13.06l-6.22 6.22a.75.75 0 0 1-1.06-1.06L10.94 12 4.72 5.78a.75.75 0 1 1 1.06-1.06L12 10.94l6.22-6.22a.75.75 0 1 1 1.06 1.06L13.06 12z"/></svg>`,
};
export const iconInfo16: {
  name: 'info-16';
  data: string;
} = {
  name: 'info-16',
  data: `<svg width="16" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M7.282 5.846h1.396V4.45H7.282m.698 9.074A5.59 5.59 0 0 1 2.396 7.94 5.59 5.59 0 0 1 7.98 2.356a5.59 5.59 0 0 1 5.584 5.584 5.59 5.59 0 0 1-5.584 5.584M7.98.96a6.98 6.98 0 1 0 0 13.96 6.98 6.98 0 0 0 0-13.96m-.698 10.47h1.396V7.242H7.282z"/></svg>`,
};
export const iconMinus16: {
  name: 'minus-16';
  data: string;
} = {
  name: 'minus-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M13.125 8.25h-8.25a.375.375 0 0 0-.375.375v.75a.375.375 0 0 0 .375.375h8.25a.375.375 0 0 0 .375-.375v-.75a.375.375 0 0 0-.375-.375"/></svg>`,
};
export type IacIcon =
  | 'arrow-down-16'
  | 'arrow-down-24'
  | 'check-16'
  | 'check-24'
  | 'close-16'
  | 'close-24'
  | 'info-16'
  | 'minus-16';
export interface IacIconInterface {
  name: IacIcon;
  data: string;
}
export type IacIconInterfaceNameSubset<T extends Readonly<IacIconInterface[]>> = T[number]['name'];
export const completeIconSet = [
  iconArrowDown16,
  iconArrowDown24,
  iconCheck16,
  iconCheck24,
  iconClose16,
  iconClose24,
  iconInfo16,
  iconMinus16,
];
